import { __assign } from 'tslib';
import React, { forwardRef, useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { useMatchMedia } from '../../../../mq/esm';
import { Scrollbar } from '../../../../scrollbar/esm';
import { isClient } from '../../../../shared/esm';
import { DEFAULT_VISIBLE_OPTIONS } from '../../consts.js';
import { useVisibleOptions, isGroup } from '../../utils.js';
import { Optgroup } from '../optgroup/Component.js';

var styles = {"optionsList":"select__optionsList_mypgi","optionsListHeader":"select__optionsListHeader_mypgi","optionsListFooter":"select__optionsListFooter_mypgi","withBorder":"select__withBorder_mypgi","scrollable":"select__scrollable_mypgi","emptyPlaceholder":"select__emptyPlaceholder_mypgi","l":"select__l_mypgi","xl":"select__xl_mypgi"};
require('./index.css');

var createCounter = function () {
    var count = 0;
    // eslint-disable-next-line no-plusplus
    return function () { return count++; };
};
var OptionsList = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 's' : _c, className = _a.className, optionGroupClassName = _a.optionGroupClassName, scrollbarClassName = _a.scrollbarClassName, Option = _a.Option, getOptionProps = _a.getOptionProps, _d = _a.options, options = _d === void 0 ? [] : _d, _e = _a.Optgroup, Optgroup$1 = _e === void 0 ? Optgroup : _e, dataTestId = _a.dataTestId, emptyPlaceholder = _a.emptyPlaceholder, _f = _a.visibleOptions, visibleOptions = _f === void 0 ? DEFAULT_VISIBLE_OPTIONS : _f, onScroll = _a.onScroll, open = _a.open, header = _a.header, footer = _a.footer, _g = _a.showFooter, showFooter = _g === void 0 ? true : _g, optionsListWidth = _a.optionsListWidth, nativeScrollbarProp = _a.nativeScrollbar, _h = _a.flatOptions, flatOptions = _h === void 0 ? [] : _h, setHighlightedIndex = _a.setHighlightedIndex;
    var query = '(max-width: 1023px)';
    var nativeScrollbar = useMatchMedia(query, function () {
        return isClient() ? window.matchMedia(query).matches : true;
    })[0];
    nativeScrollbar = Boolean(nativeScrollbarProp !== null && nativeScrollbarProp !== void 0 ? nativeScrollbarProp : nativeScrollbar);
    var renderOption = function (option, index) { return (React.createElement(Option, __assign({ key: option.key }, getOptionProps(option, index)))); };
    var listRef = useRef(null);
    var scrollbarRef = useRef(null);
    var counter = createCounter();
    var renderGroup = function (group) { return (React.createElement(Optgroup$1, { className: optionGroupClassName, label: group.label, key: group.label, size: size }, group.options.map(function (option) { return renderOption(option, counter()); }))); };
    useVisibleOptions(__assign(__assign({}, (!nativeScrollbar && { styleTargetRef: scrollbarRef })), { visibleOptions: visibleOptions, listRef: listRef, open: open, invalidate: options }));
    if (options.length === 0 && !emptyPlaceholder && !header && !footer) {
        return null;
    }
    var renderListItems = function () { return (React.createElement(React.Fragment, null,
        options.map(function (option) {
            return isGroup(option) ? renderGroup(option) : renderOption(option, counter());
        }),
        emptyPlaceholder && options.length === 0 && (React.createElement("div", { className: styles.emptyPlaceholder }, emptyPlaceholder)))); };
    var renderWithCustomScrollbar = function () {
        var scrollableNodeProps = {
            onScroll: onScroll,
            'data-test-id': dataTestId,
            ref: ref,
        };
        return (React.createElement(Scrollbar, { className: cn(styles.scrollable, scrollbarClassName), ref: scrollbarRef, horizontalAutoStretch: optionsListWidth === 'content', scrollableNodeProps: scrollableNodeProps, contentNodeProps: { ref: listRef } }, renderListItems()));
    };
    var renderWithNativeScrollbar = function () { return (React.createElement("div", { className: cn(styles.scrollable, scrollbarClassName), ref: mergeRefs([listRef, ref]), onScroll: onScroll }, renderListItems())); };
    var resetHighlightedIndex = function () { return setHighlightedIndex === null || setHighlightedIndex === void 0 ? void 0 : setHighlightedIndex(-1); };
    return (React.createElement("div", __assign({}, (nativeScrollbar && { 'data-test-id': dataTestId }), { className: cn(styles.optionsList, styles[size], className) }),
        header && (React.createElement("div", { className: styles.optionsListHeader, onMouseEnter: resetHighlightedIndex }, header)),
        nativeScrollbar ? renderWithNativeScrollbar() : renderWithCustomScrollbar(),
        showFooter && footer && (React.createElement("div", { onMouseEnter: resetHighlightedIndex, className: cn(styles.optionsListFooter, (_b = {},
                _b[styles.withBorder] = visibleOptions && flatOptions.length > visibleOptions,
                _b)) }, footer))));
});

export { OptionsList };
